// extracted by mini-css-extract-plugin
export default {"placeholderAttribute":"data-ai-compose","animatedBackground":"useAICompose-module__animatedBackground--C8usn"};